const countryGate = () => {
    if (location.pathname.split("/")[2] === "unsubscribe") {
        return;
    }

    const query = new URLSearchParams(location.search);
    if (localStorage.getItem("country_selected")) {
        if (!query.has("lang")) {
            const defaultLang = localStorage.getItem("default_lang") || "nl";
            if (defaultLang !== "nl") {
                query.set("lang", defaultLang);
                location.href = location.pathname + "?" + query.toString();
            }
        } else {
            localStorage.setItem("default_lang", query.get("lang"));
        }

        return;
    }

    if (query.get("country_selected")) {
        localStorage.setItem("country_selected", "1");
        localStorage.setItem("default_lang", query.get("lang") || "nl");
        return;
    }

    if (query.get("age_confirmed")) {
        localStorage.setItem("age_confirmed", "1");
        return;
    }

    if (!localStorage.getItem("age_confirmed")) {
        return;
    }

    if (location.pathname.split("/")[2] !== "country-gate") {
        location.href = "/" + location.pathname.split("/")[1] + "/country-gate?" + query.toString();
        return;
    }
};

countryGate();
